import React from 'react';

import PropTypes from 'prop-types';

import BaseModal from '@asteria/component-modal';

import TransactionDetails from './content';

import './styles.scss';

/**
 * @typedef { import('./types').Props } Props
 * @typedef { import('./types').ChildrenProps } ChildrenProps
 */

/**
 * @type { React.FC<Props & { open: boolean }> }
 */
const Modal = React.memo(function Modal(props) {
	const { open, onClose } = props;

	return (
		<BaseModal open={open} onClose={onClose}>
			<TransactionDetails {...props} />
		</BaseModal>
	);
});

Modal.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
};

export default Modal;
